import React, { Suspense } from 'react';
import { observer } from 'mobx-react';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';

import { Route, Switch } from 'react-router-dom';
import * as paths from 'Paths';


const ProgramRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/affiliates/program" */
    'routes/Affiliates/ProgramRoute'
  )
));

const CouponsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/affiliates/coupons" */
    'routes/Affiliates/CouponsRoute'
  )
));

const ReferralsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/affiliates/referrals" */
    'routes/Affiliates/ReferralsRoute'
  )
));


const getAffiliatesRoutes = () => {
  return [
    {path: paths.getPathAffiliateProgram(), component: ProgramRoute},
    {path: paths.getPathAffiliateCoupons(), component: CouponsRoute},
    {path: paths.getPathAffiliateReferrals(), component: ReferralsRoute},
  ]
}



export { getAffiliatesRoutes };
